import React from "react";
import AppStoreImg from "../../utils/images/app-store.jpg";
import PlaystoreImg from "../../utils/images/play-store.jpg";

export default function Footer() {
  return (
      <div className="bg-white border-t border-gray-200 w-full">
          <div className="flex flex-col sm:flex-row justify-between items-center p-6 gap-4">
            <div className="text-center sm:text-left">
                <span className="text-gray-600 text-sm">
                  © 2025 "Meqa Sığorta" ASC
                </span>
            </div>

            <div className="flex gap-3">
                <a
                    href="https://apps.apple.com/az/app/meqa-s%C4%B1%C4%9Forta/id6751800309"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                    <img
                        src={AppStoreImg}
                        alt="Download on App Store"
                        className="h-10 w-auto"
                    />
                </a>
                <a
                    href="https://play.google.com/store/apps/details?id=com.megasigorta.app&pcampaignid=web_share"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity"
                >
                    <img
                        src={PlaystoreImg}
                        alt="Get it on Google Play"
                        className="h-10 w-auto"
                    />
                </a>
            </div>
        </div>

    </div>
  );
}
